import { IShedState, createInitialState } from './state';
import { DeepPartial, deepMerge } from './utils';

type Listener = (state: IShedState) => void;

export class ShedStore {
	private state: IShedState = createInitialState();
	private listeners: Array<Listener> = [];

	getState(): IShedState {
		return this.state;
	}

	setState(patch: DeepPartial<IShedState>): void {
		deepMerge(this.state, patch);
		this.emit();
	}

	mutate(fn: (state: IShedState) => void): void {
		fn(this.state);
		this.emit();
	}

	reset(): void {
		this.state = createInitialState();
		this.emit();
	}

	subscribe(fn: Listener): () => void {
		this.listeners.push(fn);
		return () => {
			const i = this.listeners.indexOf(fn);
			if (i >= 0) this.listeners.splice(i, 1);
		};
	}

	private emit(): void {
		this.listeners.slice().forEach((fn) => fn(this.state));
	}
}

export const shedStore = new ShedStore();
